module.exports = __webpack_public_path__ + "img/friend.c922664f.png";